(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-picks-filters"] && !Shopify.designMode) return;
  try {
    
  class AfrQuickPicksFilters {
    constructor(section) {
      this.section = section;
      this.filters = Array.from(section.querySelectorAll('[data-quick-filter]'));
      this.clearButton = section.querySelector('[data-quick-clear]');
      this.filters.forEach((chip) => chip.addEventListener('click', this.onChipClick.bind(this)));
      if (this.clearButton) this.clearButton.addEventListener('click', this.onClearClick.bind(this));
      window.addEventListener('popstate', () => this.syncActiveState());
      this.syncActiveState();
    }

    isPriceFilter(chip) {
      return chip.dataset.filterType === 'price_lte' || chip.dataset.filterParam === 'filter.v.price.lte';
    }

    onChipClick(event) {
      const chip = event.currentTarget;
      const param = chip.dataset.filterParam;
      const value = chip.dataset.filterValue;
      if (!param || !value) return;
      event.preventDefault();

      const url = new URL(window.location.href);
      const active = this.isChipActive(chip, url);

      if (this.isPriceFilter(chip)) {
        if (active) {
          url.searchParams.delete(param);
        } else {
          url.searchParams.set(param, value);
        }
      } else {
        const values = url.searchParams.getAll(param);
        url.searchParams.delete(param);
        values.filter((item) => item !== value).forEach((item) => url.searchParams.append(param, item));
        if (!active) url.searchParams.append(param, value);
      }

      this.loadUrl(url);
    }

    onClearClick() {
      const url = new URL(window.location.href);

      this.filters.forEach((chip) => {
        const param = chip.dataset.filterParam;
        const value = chip.dataset.filterValue;
        if (!param || !value) return;

        if (this.isPriceFilter(chip)) {
          if (url.searchParams.get(param) === value) url.searchParams.delete(param);
          return;
        }

        const values = url.searchParams.getAll(param).filter((item) => item !== value);
        url.searchParams.delete(param);
        values.forEach((item) => url.searchParams.append(param, item));
      });

      this.loadUrl(url);
    }

    isChipActive(chip, url) {
      const param = chip.dataset.filterParam;
      const value = chip.dataset.filterValue;
      if (!param || !value) return false;
      if (this.isPriceFilter(chip)) return url.searchParams.get(param) === value;
      return url.searchParams.getAll(param).includes(value);
    }

    async loadUrl(url) {
      window.history.pushState({}, '', url);
      this.syncActiveState();

      try {
        const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        // ✅ 修复：#ResultsList 是 Horizon 主题的产品网格容器
        const selectors = ['#ResultsList', '#ProductGridContainer', '#product-grid', '.main-collection-grid', '[data-results-list]'];
        selectors.forEach((selector) => {
          const current = document.querySelector(selector);
          const fresh = parsed.querySelector(selector);
          if (current && fresh) current.innerHTML = fresh.innerHTML;
        });
      } catch (error) {
        window.location.href = url.toString();
      }
    }

    syncActiveState() {
      const url = new URL(window.location.href);
      let hasActive = false;
      this.filters.forEach((chip) => {
        const active = this.isChipActive(chip, url);
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) hasActive = true;
      });
      if (this.clearButton) this.clearButton.hidden = !hasActive;
    }
  }

  document.querySelectorAll('[data-quick-picks-section]').forEach((section) => {
    if (section.dataset.quickPicksReady) return;
    section.dataset.quickPicksReady = 'true';
    new AfrQuickPicksFilters(section);
  });

  } catch(e) { console.error(e); }
})();
})();
